import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/digitale-souveraenitaet")({
  beforeLoad: () => {
    throw redirect({
      to: "/$languageKey/$topicSlug/$pageSlug",
      params: {
        languageKey: "de",
        topicSlug: "demokratie",
        pageSlug: "digitale-souveränität",
      },
      statusCode: 301,
    });
  },
});
